/** One lowercase DNS label: the shape of an issued Helm instance slug. */
export const SLUG_RE = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/;
